import styled from "styled-components";

export const Body = styled.main`
  overflow: hidden;
  transition: all ease 0.5s;
  background-color: ${({theme}) => theme["body"]};

  .MuiTableContainer-root {
    &::-webkit-scrollbar {
      height: 8px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background: ${({theme}) =>
        theme["isDark"] ? "rgba(255, 255, 255, .15)" : "rgba(0, 0, 0, .15)"};
    }

    tbody tr {
      &:hover {
        background-color: ${({theme}) => theme["hover"]};
      }
      th,
      td {
        border-bottom: 0.8px solid ${({theme}) => theme["line"]};
      }
      &:last-child {
        th,
        td {
          border-bottom: unset;
        }
      }
    }
  }
`;
